export default __webpack_public_path__ + "static/media/bnb_sm.1c1a185e.svg";